<template>
    <form @submit.prevent="submitForm">
        <ValidationObserver v-slot="{ invalid, errors }">

            <ValidationProvider name="Email adres" rules="required|email" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-name" class="form-control-label">{{ $t('register.email') }} *</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <icon name="inbox"></icon>
                            </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.email"
                            class="form-control"
                            id="input-email"
                            :placeholder="$t('register.fill_in_email')"
                            :class="{ 'is-invalid': errors.length }"
                            required/>
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider name="Wachtwoord" rules="required" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group mb-0">
                    <label for="input-password" class="form-control-label">{{ $t('register.password') }} *</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <icon name="key"></icon>
                            </span>
                        </div>
                        <input
                            :type="passwordVisible ? 'text' : 'password'"
                            v-model="formValues.password"
                            class="form-control"
                            id="input-password"
                            :placeholder="$t('register.fill_in_password')"
                            :class="{ 'is-invalid': errors.length }"
                            required
                        />
                        <div class="input-group-append">
                                <span class="input-group-text" @click="togglePassword" style="cursor: pointer;">
                                    <icon :name="passwordVisible ? 'eye-slash' : 'eye'" style="fill: black !important;"></icon>
                                </span>
                        </div>
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <div v-if="isLiteVersion" class="form-group">
                <div class="form-check">
                    <input
                        type="checkbox"
                        v-model="formValues.remember"
                        class="form-check-input"
                        id="remember"
                    />
                    <label class="form-check-label" for="remember">{{ $t('register.remember_me') }}</label>
                </div>
            </div>
        </ValidationObserver>
    </form>
</template>

<script>

    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: "LoginForm",

        components: {
            ValidationObserver,
            ValidationProvider
        },

        data() {
            return {
                formValues: {
                    email: '',
                    password: '',
                    remember: false,
                },
                passwordVisible: false,
            };
        },
        computed: {
            isLiteVersion() {
                return !!window.IS_LITE_VERSION;
            },
        },
        methods: {
            togglePassword() {
                this.passwordVisible = !this.passwordVisible;
            },
            submitForm() {
                this.$emit('submit', this.formValues);
            },
        },
    };
</script>

